<template>
  <pt-qr-code-detail-table class="pt-qr-code-detail-table__withData" @getTableData="getTableData" :tableLabels="tableLabels" :tableData="tableData"
  :totalNumber="totalNumber" ref="table">
  <slot/>
  </pt-qr-code-detail-table>
</template>

<script>
import PtQrCodeDetailTable from './index'
export default {
  name: 'pt-qr-code-detail-table__withData',
  components: {
    'pt-qr-code-detail-table': PtQrCodeDetailTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: []
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        console.log('val', val)
        this.$refs.table.resetPage()
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        id: this.id,
        ...this.paramsData,
        pageableParam: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('qrCodeDetailList', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.console.error(err || '获取二维码详情列表失败')
      })
    }
  }
}
</script>
